import request from '../config/axiosConfig';
import {
  GET_LIST_ROLE,
  CREATE_ROLE,
  UPDATE_ROLE,
  DELETE_ROLE,
} from '../constants/apiEndPoint';

const roleService = {
  getList: async (params) => {
    const { data } = await request({ url: GET_LIST_ROLE, method: 'POST', params: params });
    return data?.data;
  },

  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_ROLE, method: 'POST', data: dataBody });
    return data;
  },

  update: async (id, dataBody) => {
    const { data } = await request({ url: UPDATE_ROLE, method: 'PUT', data: { id, ...dataBody } });
    return data;
  },

  delete: async (id) => {
    const { data } = await request({ url: DELETE_ROLE, method: 'DELETE', data: { id } });
    return data;
  },
};

export default roleService;
